'use strict';

var msPerDay = require('../helpers/timeConstants').msPerDay;

var DayFromYear = require('./DayFromYear');

// https://262.ecma-international.org/5.1/#sec-15.9.1.3

module.exports = function TimeFromYear(y) {
	return msPerDay * DayFromYear(y);
};



//////////////////
// WEBPACK FOOTER
// ./~/es-abstract/2016/TimeFromYear.js
// module id = 1326
// module chunks = 0